import { getHighlights, batchCreateNameSuper, generateSls, getNextUuid, addAppAttribution } from '@fs/zion-sls'
import { saveTaskEdits } from '../../../../../shared/services/recordEnhancement/recordEnhancementService'
import { FullNameApp } from '../../../../../shared/services/config'

export const toggleNotAPersonHelper = async ({
  notAPersonFlag,
  currentTask,
  dispatch,
  zionSlsDispatch,
  saveChangesFlag,
  triggerTaskRegeneration,
  setError,
  resetSkipCounter,
  userId,
}) => {
  try {
    resetSkipCounter()
    let slsPayload = []
    if (notAPersonFlag) {
      dispatch({ type: 'ADD_TO_NOT_PERSON_TASKS', value: currentTask.id })
      // Remove the NAME from the PERSON object and delete the NAME element.
      // Leave the name parts floating so they can be used again
      const dispatches = []
      if (currentTask.personId) {
        dispatches.push({
          type: 'REM_SUB',
          value: {
            superPartitionKey: currentTask.partitionKey,
            subPartitionKey: currentTask.partitionKey,
            superId: currentTask?.personId ? currentTask.personId : currentTask.partitionKey,
            subId: currentTask.id,
            elementType: 'PERSON',
          },
        })
      }
      dispatches.push({
        type: 'REMOVE_ELEMENT',
        value: {
          id: currentTask.id,
          partitionKey: currentTask.partitionKey,
          elementType: 'NAME',
        },
      })
      slsPayload = generateSls(dispatches) || []
    } else {
      dispatch({ type: 'REMOVE_FROM_NOT_PERSON_TASKS', value: currentTask.id })
      // Restore NAME element
      // Leave the name parts floating so they can be used again

      const nameElementDispatches = currentTask.personId
        ? batchCreateNameSuper({
            partitionKey: currentTask.partitionKey,
            nameElementId: getNextUuid(),
            nameType: currentTask.nameType,
            personId: currentTask.personId,
          })
        : [
            {
              type: 'CREATE_ELEMENT',
              value: {
                id: getNextUuid(),
                partitionKey: currentTask.partitionKey,
                extraArgs: {
                  nameType: currentTask.nameType,
                },
                elementType: 'NAME',
              },
            },
          ]

      const dispatches = nameElementDispatches
      currentTask.subElements.forEach((se) =>
        dispatches.push({
          type: 'ADD_SUB',
          value: {
            superPartitionKey: se.partitionKey,
            subPartitionKey: se.partitionKey,
            superId: nameElementDispatches[0].value.id,
            subId: se.id,
            elementType: 'NAME',
          },
        })
      )
      slsPayload = generateSls(dispatches) || []
      // Need to Remove the old NAME element from this person.  We keep it around as a place holder until we replace it here
      if (currentTask.personId) {
        dispatches.push({
          type: 'REM_SUB',
          value: {
            superPartitionKey: currentTask.partitionKey,
            subPartitionKey: currentTask.partitionKey,
            superId: currentTask.personId,
            subId: currentTask.id, // We keep around the old NAME id until now
            elementType: 'PERSON',
          },
        })
        dispatches.push({
          type: 'REMOVE_ELEMENT',
          value: {
            id: currentTask.id,
            partitionKey: currentTask.partitionKey,
            elementType: 'NAME',
          },
        })
      }
      if (currentTask.recordId) dispatches.push({ type: 'SET_RECORD_PERSON_IDS', value: currentTask.recordId })
      // Need to update the state with the new NAME element ID (it was deleted on the back end, and has been replaced with this new one)
      zionSlsDispatch({ type: 'BATCH_DISPATCHES', value: dispatches })
    }

    addAppAttribution(slsPayload, userId, FullNameApp)

    if (saveChangesFlag.isOn) {
      await saveTaskEdits(currentTask.partitionKey, slsPayload, false, false, 'Full Name Review')
    }

    // If removing, the "tasksMarkedNotAPerson" state now includes this ID, regenerating tasks just adds currentTask.notAPerson = true
    // If restoring, update useTasks state with the new NAME element and it's correspondingly new ID
    triggerTaskRegeneration(true)
  } catch (err) {
    setError(err)
  }
}

export const showHighlights = (currentTask, isSmallScreen, highlightContext) => {
  if (!currentTask?.partitionKey) return

  const currentTaskRectFieldIds = [...new Set(getHighlights({ element: currentTask }).flatMap((rect) => rect.fieldId))]

  highlightContext.setDisplayHighlights({
    mainPartitionKey: currentTask.partitionKey,
    elementIds: currentTaskRectFieldIds,
    attachFilter: (hl) => currentTaskRectFieldIds.includes(hl.fieldId),
    mainZoomFilter: (hl) => hl.attached,
    setMainZoom: true,
    isSmallScreen,
  })
}
